/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";

import { IoCheckmark } from "react-icons/io5";

import matchSorter from "match-sorter";
import Loading from "../common/Loading";

const ServiceList = ({ services, search, onClickEdit }) => {
  const columns = [
    { Header: "Code", accessor: "code" },
    { Header: "Description", accessor: "description" },
    { Header: "Department", accessor: "department.description" },
    {
      Header: "All Departments",
      accessor: "all_departments",
      Cell: (row) => (
        <div className="text-center">{row.value ? <IoCheckmark /> : ""}</div>
      )
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: (row) => (row.value ? "Active" : "Inactive"),
      maxWidth: 80
    }
  ];

  const servicesToUse = search
    ? matchSorter(services, search, {
        keys: [
          "code",
          "description",
          "department.description",
          "workplace.label"
        ]
      })
    : services;

  return (
    <ReactTable
      className="-highlight"
      data={servicesToUse}
      LoadingComponent={() => <Loading active={!services.length} />}
      columns={columns}
      getTrProps={(state, rowInfo) => ({
        onClick: () => onClickEdit(rowInfo.original)
      })}
      defaultPageSize={10}
      defaultSorted={[
        {
          id: "description",
          asc: true
        }
      ]}
    />
  );
};

ServiceList.propTypes = {
  services: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  onClickEdit: PropTypes.func.isRequired,
  search: PropTypes.string
};

export default ServiceList;
